import { useState } from "react";
import { INSIGHT_RANGES } from "../../../../shared/goals/insights";
import { Sheet } from "../../../../shared/phone/Sheet";
import { Icon } from "../../../components/ui/Icon";
import type { Dates } from "../../../lib/ccApi";
import { datesOf, daysWords, isoDay } from "../v2";
import { closeSheet } from "./parts";

/** The dates the numbers are for: each choice as a row with its check, and two days picked by hand. */
export function RangeSheet({ open, onClose, dates, onChange }: { open: boolean; onClose: () => void; dates: Dates; onChange: (d: Dates) => void }) {
  const today = isoDay(new Date());
  const [from, setFrom] = useState("from" in dates ? dates.from : "");
  const [to, setTo] = useState("to" in dates ? dates.to : today);
  const pick = (d: Dates) => {
    onChange(d);
    closeSheet();
  };
  const ok = !!from && !!to && from <= to;
  return (
    <Sheet open={open} onClose={onClose} title="Show numbers for">
      <div className="pn-grp">
        {INSIGHT_RANGES.map(([k, label]) => {
          const on = "preset" in dates && dates.preset === k;
          return (
            <button type="button" key={k} className="pn-row hm-pick" aria-pressed={on} onClick={() => pick({ preset: k })}>
              <span className="m">
                <span className="t">{label}</span>
              </span>
              <span className="v">{daysWords(datesOf({ preset: k }, null))}</span>
              <span className={on ? "hm-tick on" : "hm-tick"}>
                <Icon name="check" />
              </span>
            </button>
          );
        })}
      </div>
      <div className="pn-cap hm-gap">Pick the days</div>
      <div className="pn-grp">
        <div className="pn-irow">
          <label htmlFor="hm-from">From</label>
          <input id="hm-from" type="date" value={from} max={today} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div className="pn-irow">
          <label htmlFor="hm-to">To</label>
          <input id="hm-to" type="date" value={to} max={today} onChange={(e) => setTo(e.target.value)} />
        </div>
      </div>
      <div className="pn-pad hm-gap-s">
        <button type="button" className="pn-btn soft wide" disabled={!ok} onClick={() => pick({ from, to })}>
          Show these days
        </button>
      </div>
    </Sheet>
  );
}
